import React from 'react';

const NetWorthIcon = ({ fill, className }) => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.25 7.2152H7.75C7.3 7.2152 7 7.51805 7 7.97232V12.515C7 12.9693 7.3 13.2722 7.75 13.2722H12.25C12.7 13.2722 13 12.9693 13 12.515V7.97232C13 7.51805 12.7 7.2152 12.25 7.2152ZM12 12.2627H8V8.22469H12V12.2627ZM19.1667 11.0849H17.5V8.56119H19.1667C19.6667 8.56119 20 8.22469 20 7.71995C20 7.2152 19.6667 6.8787 19.1667 6.8787H17.5V5.19621C17.5 3.76609 16.4167 2.67248 15 2.67248H13.3333V0.989987C13.3333 0.485241 13 0.148743 12.5 0.148743C12 0.148743 11.6667 0.485241 11.6667 0.989987V2.67248H8.33333V0.989987C8.33333 0.485241 8 0.148743 7.5 0.148743C7 0.148743 6.66667 0.485241 6.66667 0.989987V2.67248H5C3.58333 2.67248 2.5 3.76609 2.5 5.19621V6.8787H0.833333C0.333333 6.8787 0 7.2152 0 7.71995C0 8.22469 0.333333 8.56119 0.833333 8.56119H2.5V11.0849H0.833333C0.333333 11.0849 0 11.4214 0 11.9262C0 12.4309 0.333333 12.7674 0.833333 12.7674H2.5V15.2911C2.5 16.7213 3.58333 17.8149 5 17.8149H6.66667V19.4974C6.66667 20.0021 7 20.3386 7.5 20.3386C8 20.3386 8.33333 20.0021 8.33333 19.4974V17.8149H11.6667V19.4974C11.6667 20.0021 12 20.3386 12.5 20.3386C13 20.3386 13.3333 20.0021 13.3333 19.4974V17.8149H15C16.4167 17.8149 17.5 16.7213 17.5 15.2911V12.7674H19.1667C19.6667 12.7674 20 12.4309 20 11.9262C20 11.4214 19.6667 11.0849 19.1667 11.0849ZM16 15.4354C16 15.9545 15.6571 16.3006 15.1429 16.3006H4.85714C4.34286 16.3006 4 15.9545 4 15.4354V5.052C4 4.53283 4.34286 4.18672 4.85714 4.18672H15.1429C15.6571 4.18672 16 4.53283 16 5.052V15.4354Z'
        fill={fill}
      />
    </svg>
  );
};

export default NetWorthIcon;
